import React from 'react';
import { FaCalendar, FaImage, FaUtensils, FaComment } from 'react-icons/fa';
import nextIcon from '../../assets/img/blog/next-icon.png';

function BlogPostItem(props) {
	return (
		<div className="single-post-item">
			<img className="post-img img-fluid" src={props.imgUrl} alt=""/>
			<h3>
				<a href="/blog-details">{props.heading}</a>
			</h3>
			<div className="post-box mb-25">
				<div className="d-flex">

					<div className="post-meta">
						<a href="/blog-details">
							<FaCalendar className="mr-10"/>
							{props.date}
						</a>
					</div>
				</div>
			</div>
			<div>
				<p>{props.post_info}</p>
			</div>
			<a href="/blog-details" className="blog-btn text-uppercase mt-15">
				continue Reading
				<img src={nextIcon} alt=""/>
			</a>
		</div>
	);
}

export default BlogPostItem;
